<template>
    <div>
      <CCol sm="12">
        <CCol sm="12" style="width: 100%; background-size: cover; margin: auto; color: #fff">
          <CCard>
            <div class="table-container font-color-171717">
              <table>
                <!-- Table Header -->
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th v-for="day in weekDates" :key="'header-' + day">{{ day }}</th>
                  </tr>
                </thead>
  
                <!-- Table Body -->
                  <!-- Iterate over departments -->
                  <tbody v-for="dept in departments" :key="'dept-' + dept.id">
                    <!-- Department Header Row with Toggle -->
                    <tr>
                      <td :colspan="weekDates.length + 1" class="department-row">
                        <img
                          :src="visibleDepartments[dept.name] ? require('@/assets/img/minus-square.png') : require('@/assets/img/Plus2.png')"
                          alt="Toggle Icon"
                          @click="toggleDepartment(dept.name)"
                          style="width:20px"
                        />
                        {{ dept.name }}
                      </td>
                    </tr>
  
                    <!-- Iterate over employees for the current department -->
                    <template v-if="visibleDepartments[dept.name]">
                      <tr v-for="emp in employees[dept.name]" :key="'emp-' + emp">
                        <!-- Employee Rows for Current Department -->
                        <td>{{ emp }}</td>
                        <td v-for="day in weekDates" :key="'day-' + day">
                          <select v-model="statusOptions[dept.name][emp]" @change="submitSchedule" class="custom-select-grey">
                            <option value="default">Default Shift</option>
                            <option value="night">Night Shift</option>
                            <option value="leave">On Leave</option>
                          </select>
                        </td>
                      </tr>
                    </template>
                </tbody>
              </table>
            </div>
          </CCard>
        </CCol>
      </CCol>
    </div>
  </template>
  
  <script>
  export default {
    name: "ShiftCalendar",
    data() {
      return {
        weekDates: this.getWeekDates(),
        departments: [
          { id: 'logistic', name: 'Logistic' },
          { id: 'hr', name: 'HR' },
          { id: 'marketing', name: 'Marketing' }
        ],
        employees: {
          Logistic: ['John Doe', 'Jane Smith'],
          HR: ['Alice Johnson', 'Bob Brown'],
          Marketing: ['Elline', 'Adam'],
        },
        shifts: ['Morning', 'Afternoon', 'Night'],
        shiftOptions: {
          Logistic: {},
          HR: {},
          Marketing: {}
        },
        statusOptions: {
          Logistic: {},
          HR: {},
          Marketing: {}
        },
        visibleDepartments: {} // Initialize with department names and default visibility
      };
    },
    methods: {
      getWeekDates() {
        const today = new Date();
        const startOfWeek = today.getDate() - today.getDay() + 1; // Adjust to start from Monday
        const weekDates = [];
        const daysOfWeek = ['M', 'T', 'W', 'T', 'F'];
  
        for (let i = 0; i < 5; i++) { // Only add 5 days for Monday to Friday
          const date = new Date(today.setDate(startOfWeek + i));
          const dayOfMonth = date.getDate();
          const dayOfWeek = daysOfWeek[i];
          weekDates.push(`${dayOfMonth} ${dayOfWeek}`);
        }
  
        return weekDates;
      },
      initializeOptions() {
        this.departments.forEach(dept => {
          // Initialize visibility for each department
          this.$set(this.visibleDepartments, dept.name, true);
          this.employees[dept.name].forEach(emp => {
            if (!this.shiftOptions[dept.name][emp]) {
              this.$set(this.shiftOptions[dept.name], emp, 'default');
            }
            if (!this.statusOptions[dept.name][emp]) {
              this.$set(this.statusOptions[dept.name], emp, 'default');
            }
          });
        });
      },
      submitSchedule() {
        console.log('Submitted Schedule:', {
          shiftOptions: this.shiftOptions,
          statusOptions: this.statusOptions,
        });
        // Logic to save the schedule data to your server
      },
      toggleDepartment(departmentName) {
        this.visibleDepartments[departmentName] = !this.visibleDepartments[departmentName];
      }
    },
    created() {
      this.initializeOptions();
    }
  };
  </script>
  
  <style scoped>
  .table-container {
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th,
  td {
    padding: 8px;
    text-align: left;
    padding: 12px var(--Other-Gap-11, 24px);
  }
  
  .department-row {
    font-weight: bold;
    text-align: left;
    border-bottom: 1px rgba(11, 99, 246, 0.10);
    background: rgba(11, 99, 246, 0.10);
    height: 44px;
    padding: 12px var(--Other-Gap-11, 24px);
  }
  
  .custom-select-grey {
    background-color: #f0f0f0;
  }
  
  img {
    cursor: pointer;
    margin-right: 8px;
  }
  </style>
  